import { isOfType } from '../../../../ts-utils';
import { getReactionsState } from './comments-reaction-selectors';
import { ensureMemberHasRightTo } from '../../members/members-actions';
import { biInitiateReaction } from '../../actions/bi-actions';
import { extractCurrentOwnerIdentity } from '../../members/members-selectors';
import { resolveMemberType } from '../comments-permissions';
import { getMessageFromError } from '../comments-errors';
export const REACT_TO_COMMENT_REQUEST = 'REACT_TO_COMMENT_REQUEST';
export const REACT_TO_COMMENT_FAILURE = 'REACT_TO_COMMENT_FAILURE';
export const REACT_TO_COMMENT_SUCCESS = 'REACT_TO_COMMENT_SUCCESS';
export const reactToCommentRequest = (payload) => ({
    type: REACT_TO_COMMENT_REQUEST,
    payload,
});
export const reactToCommentSuccess = (payload) => ({
    type: REACT_TO_COMMENT_SUCCESS,
    payload,
});
export const reactToCommentFailure = (payload) => ({
    type: REACT_TO_COMMENT_FAILURE,
    payload,
});
export function reactToComment({ reactionCode, resourceId, commentId, }) {
    return async (dispatch, getState, { commentsService }) => {
        const state = getState();
        const commentState = getCommentState({ state: state.comments[resourceId], commentId });
        if (!commentState) {
            return;
        }
        const isInitiatedByGuest = resolveMemberType(state.members.currentOwner) === 'VISITOR';
        let reactionsStateOUT = getReactionsState(commentState.reactions, state.members);
        if (reactionsStateOUT.pending) {
            return; // We skip all clicks if reaction is pending
        }
        if (isInitiatedByGuest) {
            dispatch(biInitiateReaction({
                reactionCode,
                resourceId,
                commentId,
                subaction: getSubaction({ reactionCode, state: reactionsStateOUT }),
            }));
        }
        const permissionResult = await dispatch(ensureMemberHasRightTo({
            userAction: 'REACT',
            resourceId,
            commentId,
        }));
        if (permissionResult !== 'OK') {
            return dispatch(reactToCommentFailure({
                resourceId,
                commentId,
                message: getMessageFromError(permissionResult === 'ACTION_CANCELLED' ? { type: 'SILENT' } : { type: 'PERMISSION' }),
            }));
        }
        if (isInitiatedByGuest && state.members.currentOwner.type === 'MEMBER') {
            // update state after login
            const updatedCommentState = getCommentState({
                state: state.comments[resourceId],
                commentId,
            });
            if (!updatedCommentState) {
                return;
            }
            reactionsStateOUT = getReactionsState(updatedCommentState.reactions, state.members);
            if (reactionsStateOUT.activeReaction === reactionCode) {
                return;
            }
        }
        else if (!isInitiatedByGuest && state.members.currentOwner.type === 'MEMBER') {
            dispatch(biInitiateReaction({
                reactionCode,
                resourceId,
                commentId,
                subaction: getSubaction({ reactionCode, state: reactionsStateOUT }),
            }));
        }
        const subaction = getSubaction({ reactionCode, state: reactionsStateOUT });
        dispatch(reactToCommentRequest({
            reactionCode,
            resourceId,
            commentId,
            subaction,
        }));
        const requestParams = {
            commentId,
            reactionCode,
        };
        const initiatorIdentity = extractCurrentOwnerIdentity(state.members);
        const result = subaction === 'REMOVE'
            ? await commentsService.removeReaction(requestParams)
            : await commentsService.addReaction(requestParams);
        result.type === 'SUCCESS'
            ? dispatch(reactToCommentSuccess({
                commentId,
                reactionCode,
                resourceId,
                subaction,
                initiatorIdentity,
            }))
            : dispatch(reactToCommentFailure({
                resourceId,
                commentId,
                message: getMessageFromError(result.error),
            }));
    };
}
const getCommentState = ({ state, commentId, }) => {
    if (state?.type !== 'READY') {
        return undefined;
    }
    const commentState = state.commentsById[commentId];
    if (!('reactions' in commentState)) {
        return undefined;
    }
    else {
        return commentState;
    }
};
const getSubaction = ({ reactionCode, state, }) => {
    const isReplaceSubaction = ({ reactionCode, state, }) => typeof state.activeReaction !== 'undefined' && state.activeReaction !== reactionCode;
    return isReplaceSubaction({ reactionCode, state })
        ? 'REPLACE'
        : state.reactions.find((r) => r.reactionCode === reactionCode && r.hasReacted)
            ? 'REMOVE'
            : 'ADD';
};
export const isCommmentsReactionAction = isOfType([REACT_TO_COMMENT_REQUEST, REACT_TO_COMMENT_FAILURE, REACT_TO_COMMENT_SUCCESS]);
//# sourceMappingURL=comments-reaction-actions.js.map